// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1205": "21b273d5","3287": "655d9f3c","3319": "a5f73086","4826": "940cb052",}[chunkId] + ".css"
}